import ApiService from '@/core/services/api.service';

const resource = 'v1/platform-integration';

export default {
  async getAuthUrl(platform) {
    try {
      const response = await ApiService.get(`${resource}/auth-url`, {
        params: { platform },
      });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching auth URL:', error);
      throw error;
    }
  },

  async handleCallback(platform, code, state, shopId) {
    try {
      const response = await ApiService.post(`${resource}/callback`, {
        platform,
        code,
        state,
        shopId,
      });
      return response.data.data;
    } catch (error) {
      console.error('Error handling OAuth callback:', error);
      throw error;
    }
  },

  async getAvailableShops(platform) {
    try {
      const response = await ApiService.get(`${resource}/shops`, {
        params: { platform },
      });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching available shops:', error);
      throw error;
    }
  },

  /**
   * POST /v1/platform-integration/config — cập nhật một phần cấu hình kết nối.
   * Bắt buộc: configId. Cần ít nhất storeId (có giá trị) hoặc gửi key installmentAccountId
   * (có thể null để gỡ TK trả góp).
   * Ví dụ: { configId, storeId: 3 } | { configId, installmentAccountId: 12 } | { configId, installmentAccountId: null }
   */
  async saveConfig(data) {
    try {
      const response = await ApiService.post(`${resource}/config`, data);
      return response.data.data;
    } catch (error) {
      console.error('Error saving configuration:', error);
      throw error;
    }
  },

  async getConfigs(filters = {}) {
    try {
      const response = await ApiService.query(resource + '/configs', {
        params: filters,
      });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching configurations:', error);
      throw error;
    }
  },

  async getConfigDetail(id) {
    try {
      const response = await ApiService.get(`${resource}/config/${id}`);
      return response.data.data;
    } catch (error) {
      console.error('Error fetching configuration detail:', error);
      throw error;
    }
  },

  async updateStoreAssociation(id, storeId) {
    try {
      const response = await ApiService.put(`${resource}/config/${id}/store`, {
        storeId,
      });
      return response.data.data;
    } catch (error) {
      console.error('Error updating store association:', error);
      throw error;
    }
  },

  async refreshToken(id) {
    try {
      const response = await ApiService.post(
        `${resource}/config/${id}/refresh`,
      );
      return response.data.data;
    } catch (error) {
      console.error('Error refreshing token:', error);
      throw error;
    }
  },

  async disconnect(id) {
    try {
      const response = await ApiService.delete(`${resource}/config/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error disconnecting platform:', error);
      throw error;
    }
  },

  async syncProducts(configId, syncInventory = true) {
    try {
      const response = await ApiService.post(
        `${resource}/products/sync/${configId}`,
        { syncInventory },
      );
      return response.data.data;
    } catch (error) {
      console.error('Error syncing products:', error);
      throw error;
    }
  },

  async getAllProducts(configId, platform, page, pageSize, filters = {}) {
    try {
      const params = {
        configId,
        platform,
        page,
        pageSize,
        ...filters,
      };
      const response = await ApiService.query(`${resource}/products/all`, {
        params,
      });
      return response.data.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  async syncSingleProduct(platformProductId) {
    try {
      const response = await ApiService.post(
        `${resource}/products/sync-single/${platformProductId}`,
      );
      return response.data;
    } catch (error) {
      console.error('Error syncing single product:', error);
      throw error;
    }
  },

  async updateIsSyncInventory(platformProductId, isSyncInventory, configId) {
    try {
      const url = configId
        ? `${resource}/products/${platformProductId}/is-sync-inventory?configId=${configId}`
        : `${resource}/products/${platformProductId}/is-sync-inventory`;
      const response = await ApiService.patch(url, { isSyncInventory });
      return response.data?.data;
    } catch (error) {
      console.error('Error updating isSyncInventory:', error);
      throw error;
    }
  },
};
